<template>
  <div class="v-medication">
    <div class="d-flex justify-space-between">
      <h2 class="mb-8">{{ $ucfirst($t("medication.medicationAdherence")) }}</h2>
      <level-of-guidance-indicator
          behaviourComponent="MEDICATIONS"
        ></level-of-guidance-indicator>
      </div>
    <medication-button-line />
    <router-view></router-view>
    <discussion-step-nav-buttons
      :nextRoutes="nextDiscussionStep"
      :prevRoutes="prevDiscussionStep"
    >
    </discussion-step-nav-buttons>
  </div>
</template>

<script>
import DiscussionStepNavButtons from '../../../components/Parts/DiscussionStepNavButtons.vue';
import MedicationButtonLine from "../../../components/Parts/MedicationButtonLine";
import LevelOfGuidanceIndicator from "../../../components/Parts/LevelOfGuidanceIndicator.vue";

/**
 * Component PatientOverviewMedication.vue
 *
 * @module PatientOverviewMedication
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.6] app/src/APP_DASHBOARD/templates/views/Patient/Medication/PatientOverviewMedication.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'PatientOverviewMedication',
  props: ['nextDiscussionStep', 'prevDiscussionStep'],
  components: {
    MedicationButtonLine,
    LevelOfGuidanceIndicator,
    DiscussionStepNavButtons
  },
};
</script>
